import React from "react"

const TitleSecun = (props) => (
    <h3 className="title-second mb-30">
        {props.title}
    </h3>
)
export default TitleSecun